import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import { servicePaletteOptions } from '../../core/styles';
import { lighten } from '@material-ui/core/styles';
import {
  SERVICE_COLOR,
  SERVICE_DARK,
  SERVICE_LIGHT,
  TEXT_SECONDARY,
} from '../../core/styles/variables';

const theme = createMuiTheme({
  palette: {
    ...servicePaletteOptions,
    text: {
      primary: '#333333',
      secondary: TEXT_SECONDARY,
    },
  },
  shape: {
    borderRadius: 5,
  },
  props: {
    background: {
      primary: '#FAF9F5',
      secondary: '#FDF9EA',
      third: '#F2E8D6',
    },
    palette: {
      primary: {
        light: SERVICE_LIGHT,
        main: SERVICE_COLOR,
        dark: SERVICE_DARK,
        contrastText: '#fff',
      },
      secondary: {
        main: '#940015',
      },
    },
    border: {
      primary: '#E8D6B3',
    },
  },
  overrides: {
    MuiLink: {
      root: {
        color: '#004AD6',
        '&:hover, &:focus': {
          color: lighten('#004AD6', 0.3),
        },
      },
    },
  },
});

export default theme;
